// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"e6889d3c","563":"6ac4d8b6","815":"d62b4755","834":"967ca9c3"}[chunkId] + ".chunk.js";
};